/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { MessageFromJSON, MessagesToJSON, } from '../models/index';
/**
 *
 */
export class ChatApi extends runtime.BaseAPI {
    /**
     * Free interface to chat with Toki GPT
     * Free interface to chat with Toki GPT
     */
    async askTokiGPTV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/v1/tokigpt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MessagesToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }
    /**
     * Free interface to chat with Toki GPT
     * Free interface to chat with Toki GPT
     */
    async askTokiGPTV1(requestParameters = {}, initOverrides) {
        const response = await this.askTokiGPTV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
}
